export type ChartColorUtility = 'bg' | 'stroke' | 'fill' | 'text';

export type ChartColor =
  | 'blue'
  | 'emerald'
  | 'violet'
  | 'amber'
  | 'gray'
  | 'indigo'
  | 'orange'
  | 'rose'
  | 'transparent';

const CHART_COLOR_CLASSES: Record<
  ChartColor,
  Record<ChartColorUtility, string>
> = {
  blue: {
    bg: 'bg-utility-blue-500',
    stroke: 'stroke-utility-blue-500',
    fill: 'fill-utility-blue-500',
    text: 'text-utility-blue-500',
  },
  emerald: {
    bg: 'bg-utility-success-500',
    stroke: 'stroke-utility-success-500',
    fill: 'fill-utility-success-500',
    text: 'text-utility-success-500',
  },
  violet: {
    bg: 'bg-utility-violet-500',
    stroke: 'stroke-utility-violet-500',
    fill: 'fill-utility-violet-500',
    text: 'text-utility-violet-500',
  },
  amber: {
    bg: 'bg-utility-warning-500',
    stroke: 'stroke-utility-warning-500',
    fill: 'fill-utility-warning-500',
    text: 'text-utility-warning-500',
  },
  gray: {
    bg: 'bg-utility-gray-500',
    stroke: 'stroke-utility-gray-500',
    fill: 'fill-utility-gray-500',
    text: 'text-utility-gray-500',
  },
  indigo: {
    bg: 'bg-utility-indigo-500',
    stroke: 'stroke-utility-indigo-500',
    fill: 'fill-utility-indigo-500',
    text: 'text-utility-indigo-500',
  },
  orange: {
    bg: 'bg-utility-orange-500',
    stroke: 'stroke-utility-orange-500',
    fill: 'fill-utility-orange-500',
    text: 'text-utility-orange-500',
  },
  rose: {
    bg: 'bg-utility-rose-500',
    stroke: 'stroke-utility-rose-500',
    fill: 'fill-utility-rose-500',
    text: 'text-utility-rose-500',
  },
  transparent: {
    bg: 'bg-transparent',
    stroke: 'stroke-transparent',
    fill: 'fill-transparent',
    text: 'text-transparent',
  },
};

export const DEFAULT_CHART_COLORS: ChartColor[] = [
  'blue',
  'emerald',
  'violet',
  'amber',
  'gray',
  'indigo',
  'orange',
  'rose',
];

/** Maps series and colour utilities onto design-token Tailwind classes. */
export class ChartColorHelper {
  static className(color: ChartColor, utility: ChartColorUtility): string {
    return CHART_COLOR_CLASSES[color][utility];
  }

  /** Assigns a colour to each category in order, cycling through the palette. */
  static categoryColors(
    categories: string[],
    colors: ChartColor[] = DEFAULT_CHART_COLORS
  ): Map<string, ChartColor> {
    const map = new Map<string, ChartColor>();
    categories.forEach((category, index) => {
      map.set(category, colors[index % colors.length] ?? 'gray');
    });
    return map;
  }
}
